import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Company Update API Call
 * @param {string|number} companyId - Company ID
 * @param {Object} companyData - { name, address1, address2, contact_name, contact_phone, bank_name, iban_number, swift_code, manager_name, service_type }
 * @returns {Promise<Object>} - Response data from the API
 */
export const companyUpdate = async (companyId, companyData) => {
  try {
    const formData = new FormData();
    
    // Append all company data to form data
    Object.keys(companyData).forEach(key => {
      if (companyData[key] !== undefined && companyData[key] !== null) {
        formData.append(key, companyData[key]);
      }
    });

    const response = await apiClient.post(
      API_ENDPOINTS.COMPANY_EDIT.replace(':companyId', companyId),
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
}; 